import { render, staticRenderFns } from "./DocumentTagsSelect.vue?vue&type=template&id=1c6cbd74&"
import script from "./DocumentTagsSelect.vue?vue&type=script&lang=js&"
export * from "./DocumentTagsSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports